import type { ReactElement } from "react";
import { mojo } from "../../palette";

interface IInlineErrorSpanProps {
  children: string;
}

export default function InlineErrorSpan({ children, ...props }: IInlineErrorSpanProps): ReactElement {
  return (
    <span
      css={{
        fontSize: 13,
        lineHeight: 1.33,
        letterSpacing: 0.6,
        color: mojo,
        fontWeight: 500,
      }}
      {...props}
    >
      {children}
    </span>
  );
}
